import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import s from './Button.module.scss';

const Button = ({
    title = '',
    description = '',
    className = null,
    modifier = 'Primary',
    size = 'Large',
    icon = null,
    url = null,
    target = null,
    rel = null,
    attrTitle = null,
    type = null,
    disabled = null,
    onClick = null,
    isFullWidth = false,
    isActive = false,
    extraClasses = [],
    showIconBefore = false,
    isSave = false,
    loading = false,
    ...restProps
}) => {
    const isButton = !url;
    const Tag = isButton ? 'button' : 'a';
    const defaultType = isButton ? (type ? type : 'button') : null;
    const isFilter = modifier === 'Filter' || modifier === 'FilterAlternative';

    const showIconBeforeText = showIconBefore || isFilter;

    const classes = classNames(
        className,
        s.Root,
        [s[`Root--${modifier}`]],
        [s[`Root--${size}`]],
        { [s[`Root--${icon}`]]: icon },
        { [s['Root--Disabled']]: disabled },
        { [s['Root--FullWidth']]: isFullWidth },
        { [s['Root--Active']]: isActive },
        { [s['Root--Save']]: isSave },
        { [s['Root--Loading']]: loading },
        ...extraClasses
    );

    return (
        <Tag
            className={classes}
            href={url}
            target={target}
            rel={rel}
            title={attrTitle}
            type={defaultType}
            aria-disabled={disabled}
            disabled={disabled}
            onClick={onClick}
            {...restProps}>
            {icon && showIconBeforeText && (
                <Icon name={icon} className={s.IconBefore} />
            )}
            {title && <span className={s.Title}>{title}</span>}
            {isFilter && description && (
                <span className={s.Description}>{description}</span>
            )}
            {icon && (
                <div className={s.IconWrapper}>
                    <Icon name={icon} className={s.IconHover} />
                    <Icon name={icon} className={s.Icon} />
                </div>
            )}
        </Tag>
    );
};

Button.propTypes = {
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    url: PropTypes.string,
    target: PropTypes.string,
    rel: PropTypes.string,
    attrTitle: PropTypes.string,
    type: PropTypes.string,
    modifier: PropTypes.oneOf(['Primary', 'Secondary', 'Toggle']),
    size: PropTypes.oneOf([null, '', 'Small', 'Large']),
    icon: PropTypes.oneOf([null, '', 'Arrow']),
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
};

export default Button;
